"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBarInput = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const combobox_1 = require("@reach/combobox");
const fa_1 = require("react-icons/fa");
function SearchBarInput(_a) {
    var { className, onSearch, buttonProps, buttonClassName, label } = _a, props = __rest(_a, ["className", "onSearch", "buttonProps", "buttonClassName", "label"]);
    return (react_1.default.createElement("div", { className: "relative flex-auto w-full" },
        react_1.default.createElement("label", { htmlFor: "global-search", className: "sr-only" }, label),
        react_1.default.createElement(combobox_1.ComboboxInput, Object.assign({ id: "global-search", type: "search", className: (0, classnames_1.default)('flex-auto w-full rounded-3xl px-5 py-2 pr-16 text-base border-[#cccccc] focus:border-[#cccccc] solid-focus-ring', className), selectOnClick: true, autoComplete: "off" }, props)),
        react_1.default.createElement("button", Object.assign({ onClick: (e) => {
                e.preventDefault();
                onSearch === null || onSearch === void 0 ? void 0 : onSearch(e);
            }, className: (0, classnames_1.default)('absolute top-0 right-0 h-full pl-6 pr-4 text-xl rounded-r-3xl text-blue hover:text-blue-hover transition duration-200 ease-in-out solid-focus-ring', buttonClassName) }, buttonProps),
            react_1.default.createElement(fa_1.FaSearch, null))));
}
exports.SearchBarInput = SearchBarInput;
